export interface ArtifactEnvironmentDisplayInput {
  environment_name?: string | null
  environment_kind?: string | null
  pr_number?: number | null
  pr_repo_full_name?: string | null
}

export interface ArtifactEnvironmentDisplay {
  label: string
  kind: string
  pullRequestUrl: string | null
}

// Preview environments are most useful when identified by the concrete deployment that produced the
// bug. Preserve the PR link for historical PR bugs that predate environment provenance; all other
// legacy rows truthfully remain project-default runs rather than being relabelled as Production.
export function artifactEnvironmentDisplay(artifact: ArtifactEnvironmentDisplayInput): ArtifactEnvironmentDisplay {
  const isPreviewPullRequest = artifact.pr_number != null
    && !!artifact.pr_repo_full_name
    && (artifact.environment_kind === 'preview' || !artifact.environment_name)
  if (isPreviewPullRequest) {
    return {
      label: `PR #${artifact.pr_number}`,
      kind: 'preview',
      pullRequestUrl: `https://github.com/${artifact.pr_repo_full_name}/pull/${artifact.pr_number}`,
    }
  }
  return {
    label: artifact.environment_name?.trim() || 'Project default',
    kind: artifact.environment_kind?.trim().toLowerCase() || 'default',
    pullRequestUrl: null,
  }
}
